// 客户管理
export default [

  //客户列表
  {
    path: '/customerList',
    name: 'customerList',
    component: () => import( /* webpackChunkName: "userManagement" */ '@/views/home/userManagement/customerList'),
    meta: {
      activeMenu: 'customerList', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //SASS客户列表
  {
    path: '/sassCustomerList',
    name: 'sassCustomerList',
    component: () => import( /* webpackChunkName: "userManagement" */ '@/views/home/userManagement/customerList/sassCustomerList'),
    meta: {
      activeMenu: 'sassCustomerList', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //标签管理
  {
    path: '/labelManagement',
    name: 'labelManagement',
    component: () => import( /* webpackChunkName: "userManagement" */ '@/views/home/userManagement/labelManagement'),
    meta: {
      activeMenu: 'labelManagement', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //客户分配
  {
    path: '/customerAllocation',
    name: 'customerAllocation',
    component: () => import( /* webpackChunkName: "userManagement" */ '@/views/home/userManagement/customerAllocation'),
    meta: {
      activeMenu: 'customerAllocation', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //采购分配
  {
    path: '/purchaseAllocation',
    name: 'purchaseAllocation',
    component: () => import( /* webpackChunkName: "userManagement" */ '@/views/home/userManagement/purchaseAllocation'),
    meta: {
      activeMenu: 'purchaseAllocation', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //配货分配
  {
    path: '/distributionAllocation',
    name: 'distributionAllocation',
    component: () => import( /* webpackChunkName: "userManagement" */ '@/views/home/userManagement/distributionAllocation'),
    meta: {
      activeMenu: 'distributionAllocation', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //券汇总列表
  {
    path: '/couponSummaryList',
    name: '/couponSummaryList',
    component: () => import( /* webpackChunkName: "userManagement" */ '@/views/home/userManagement/couponSummaryList'),
    meta: {
      activeMenu: 'couponSummaryList', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //店铺授权
  {
    path: '/storeAuthorization',
    name: '/storeAuthorization',
    component: () => import( /* webpackChunkName: "userManagement" */ '@/views/home/userManagement/storeAuthorization'),
    meta: {
      activeMenu: 'storeAuthorization', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },
  //商品管理业务汇总
  {
    path: '/productManag',
    name: '/productManag',
    component: () => import( /* webpackChunkName: "userManagement" */ '@/views/home/userManagement/productManag'),
    meta: {
      activeMenu: 'productManag', // 可用选中菜单
      // keepAlive: true // true 开启。
    }
  },





]